import { Row, Col } from "antd";
import Subtitle from "../../Subtitle";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";
import {
  Building,
  LampCeiling,
  Sunset,
  ParkingCircle,
  ChevronsDown,
  ChevronsUp,
  Sigma,
} from "lucide-react";

export default function Nom007Section(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <>
      <Subtitle title="Información de los interiores a verificar" marginTop={16} />
      <Row gutter={[16, 16]}>
        <Col {...responsiveInfo}>
          <DataGroup
            icon={<Building size={16} />}
            title={"Tipo de Edificio"}
            formName={"Tipo de Edificio"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<Building size={16} />}
              iconColor="#1890ff"
              keyName="Tipo de Edificio"
              value={verification?.TipoEdificio}
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
        <Col {...responsiveInfo}>
          <DataGroup
            icon={<LampCeiling size={16} />}
            title={"DPEA Interior"}
            formName={"DPEA Interior"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<ChevronsDown size={16} />}
              iconColor="#1890ff"
              keyName="Mínimo"
              value={verification?.DPEAInteriorMin}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<ChevronsUp size={16} />}
              iconColor="#82cc4b"
              keyName="Máximo"
              value={verification?.DPEAInteriorMax}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Sigma size={16} />}
              iconColor="#ffc53d"
              keyName="Promedio"
              value={verification?.DPEAIInteriorProm}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
        <Col {...responsiveInfo}>
          <DataGroup
            icon={<Sunset size={16} />}
            title={"DPEA Exterior"}
            formName={"DPEA Exterior"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<ChevronsDown size={16} />}
              iconColor="#1890ff"
              keyName="Mínimo"
              value={verification?.DPEAExteriorMin}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<ChevronsUp size={16} />}
              iconColor="#82cc4b"
              keyName="Máximo"
              value={verification?.DPEAExteriorMax}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Sigma size={16} />}
              iconColor="#ffc53d"
              keyName="Promedio"
              value={verification?.DPEAIExteriorProm}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
        <Col {...responsiveInfo}>
          <DataGroup
            icon={<ParkingCircle size={16} />}
            title={"DPEA Estacionamiento"}
            formName={"DPEA Estacionamiento"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<ChevronsDown size={16} />}
              iconColor="#1890ff"
              keyName="Mínimo"
              value={verification?.DPEAEstacionamientoMin}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<ChevronsUp size={16} />}
              iconColor="#82cc4b"
              keyName="Máximo"
              value={verification?.DPEAEstacionamientoMax}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Sigma size={16} />}
              iconColor="#ffc53d"
              keyName="Promedio"
              value={verification?.DPEAEstacionamientoProm}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
      </Row>
    </>
  );
}